/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "universe.namespace",
    title: "Universe Namespace",
    description: "A Universe namespace identifier. Supports optional user prefix and dotted namespace segments.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validNamespace: {
            must: true,
            run: function () {
                return validate({}, "ua.navbar.item");
            }
        },
        validWithUserPrefix: {
            must: true,
            run: function () {
                return validate({}, "@thanos/universe.home");
            }
        },
        invalid: {
            throw: "fields.universe.namespace.invalid",
            run: function () {
                return validate({}, "bad namespace value");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Universe Namespace",
            description: "Namespace must be dot-separated, with optional @user/ prefix.",
            template: "Invalid universe namespace: '${value}'"
        }
    }
});

var universeNamespacePattern = /^(@[a-z0-9_.-]+\/)?[a-z_$][a-z0-9_$]*(\.[a-z_$][a-z0-9_$]*)*$/i;

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    if (!universeNamespacePattern.test(value)) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
